import * as React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Grid,
    Paper,
    Chip,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    IconButton,
} from "@material-ui/core";
import { Planning, Routing, RaceSchedule, RaceState } from "src/api/model";
import Forward from '@material-ui/icons/Forward';
import { Link } from "react-router-dom";

export interface PlanningDetailsModalProps {
    open: boolean;
    planning: Planning | null;
    onClose: () => void;
}

export const PlanningDetailsModal: React.SFC<PlanningDetailsModalProps> = (props: PlanningDetailsModalProps) => {
    console.log('PlanningDetailsModal props:', props);

    if (!props.planning) {
        console.log('No planning data, returning null');
        return null;
    }

    const { planning } = props;

    // const formatDate = (dateString: string) => {
    //     try {
    //         return new Date(dateString).toLocaleString('es-ES', {
    //             year: 'numeric',
    //             month: '2-digit',
    //             day: '2-digit',
    //             hour: '2-digit',
    //             minute: '2-digit'
    //         });
    //     } catch {
    //         return dateString;
    //     }
    // };

    const formatState = (state: RaceState | undefined) => {
        switch (state) {
            case 'CREATED':
                return 'Creada';
            case 'ASSIGNED':
                return 'Asignada';
            case 'IN_PROGRESS':
                return 'En Progreso';
            case 'DELIVERED':
                return 'Entregada';
            case 'CANCELLED':
                return 'Cancelada';
            default:
                return 'Desconocido';
        }
    };

    return (
        <Dialog
            open={props.open}
            onClose={props.onClose}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle>
                <Typography style={{ fontSize: '16px', fontWeight: 'bold' }}>
                    Detalles de Planificación {planning.id || 'N/A'}
                </Typography>
            </DialogTitle>

            <DialogContent>
                {/* Información general de la planificación */}
                <Paper style={{ padding: 16, marginBottom: 16 }}>
                    <Typography gutterBottom>
                        Información General
                    </Typography>
                    <Grid container>
                        <Grid item xs={12} sm={6} md={3}>
                            <Typography variant="body2" color="textSecondary">
                                Total KM
                            </Typography>
                            <Typography>
                                {planning.totalKm.toFixed(2)} km
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <Typography variant="body2" color="textSecondary">
                                Vehículos
                            </Typography>
                            <Typography>
                                {planning.totalVehicles}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <Typography variant="body2" color="textSecondary">
                                Total Cajas
                            </Typography>
                            <Typography>
                                {planning.totalBoxes}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <Typography variant="body2" color="textSecondary">
                                Conductores
                            </Typography>
                            <Typography>
                                {planning.routings.length}
                            </Typography>
                        </Grid>
                    </Grid>
                </Paper>

                {/* Detalles de cada routing */}
                {planning.routings.map((routing: Routing, routingIndex: number) => (
                    <Paper key={routingIndex} style={{ padding: 16, marginBottom: 16 }}>
                        <Typography gutterBottom>
                            Conductor {routingIndex + 1} - ID: {routing.driver && routing.driver.id}
                        </Typography>

                        <Typography variant="body2" color="textSecondary" gutterBottom>
                            Programación de Carreras ({routing.raceSchedules.length} día{routing.raceSchedules.length !== 1 ? 's' : ''})
                        </Typography>

                        {routing.raceSchedules.length > 0 ? (
                            <Table >
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Orden</TableCell>
                                        <TableCell>Fecha y Hora</TableCell>
                                        <TableCell>Conductor</TableCell>
                                        <TableCell>Carreras</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {[...routing.raceSchedules].sort((a, b) => (a.order || 0) - (b.order || 0)).map((schedule: RaceSchedule, scheduleIndex: number) => (
                                        <TableRow key={scheduleIndex}>
                                            <TableCell>
                                                {schedule.order}
                                            </TableCell>
                                            <TableCell>
                                                {schedule.visitDateTimeSchedule}
                                            </TableCell>
                                            <TableCell>
                                                <Chip
                                                    label={schedule.driver && schedule.driver.user && schedule.driver.user.name || "Desconocido"}
                                                    color="primary"
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <Chip
                                                    label={schedule.raceDetails && `${schedule.raceDetails.length} carrera${schedule.raceDetails.length !== 1 ? 's' : ''}`}
                                                    color="secondary"
                                                />
                                            </TableCell>
                                        </TableRow>


                                    ))}
                                </TableBody>
                            </Table>
                        ) : (
                            <Typography variant="body2" color="textSecondary" style={{ fontStyle: 'italic' }}>
                                No hay programaciones asignadas
                            </Typography>
                        )}

                        {/* Lista de carreras con scroll */}
                        {routing.raceSchedules.some(schedule => Boolean(schedule.raceDetails && schedule.raceDetails.length > 0)) && (
                            <Paper style={{ padding: 16, marginTop: 16, maxHeight: 300, overflowY: 'auto' }}>
                                <Typography variant="body2" gutterBottom style={{ fontWeight: 'bold' }}>
                                    Detalles de Carreras
                                </Typography>
                                {[...routing.raceSchedules].sort((a, b) => (a.order || 0) - (b.order || 0)).map((schedule: RaceSchedule) => (
                                    schedule.raceDetails && schedule.raceDetails.length > 0 && (
                                        <div key={`races-${schedule.order}`} style={{ marginBottom: 16 }}>
                                            <Typography variant="body2" color="textSecondary" style={{ marginBottom: 8 }}>
                                                Día {schedule.order} - {schedule.visitDateTimeSchedule}
                                            </Typography>
                                            <Table >
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>ID Carrera</TableCell>
                                                        <TableCell>Origen</TableCell>
                                                        <TableCell>Destino</TableCell>
                                                        <TableCell>Estado</TableCell>
                                                        <TableCell>Ver detalle</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {schedule.raceDetails.map((race, raceIndex) => (
                                                        <TableRow key={raceIndex}>
                                                            <TableCell>
                                                                <Typography >
                                                                    {race.id || 'N/A'}
                                                                </Typography>
                                                            </TableCell>
                                                            <TableCell>
                                                                <Typography >
                                                                    {race.branch && race.branch.name && race.branch.name ? race.branch.name : race.observation && race.observation.includes('Descanso programado') ? 'Descanso' : ' N/A'}
                                                                </Typography>
                                                            </TableCell>
                                                            <TableCell>
                                                                <Typography >
                                                                    {race.branchDestiny && race.branchDestiny.name && race.branchDestiny.name ? race.branchDestiny.name : race.observation && race.observation.includes('Descanso programado') ? 'Descanso' : ' N/A'}
                                                                </Typography>
                                                            </TableCell>
                                                            <TableCell>
                                                                <Chip
                                                                    label={formatState(race.state)}
                                                                    color={
                                                                        race.state === 'DELIVERED' ? 'primary' :
                                                                            race.state === 'CANCELLED' ? 'secondary' :
                                                                                race.state === 'IN_PROGRESS' ? 'default' :
                                                                                    'default'
                                                                    }
                                                                />
                                                            </TableCell>
                                                            <TableCell>
                                                                <Link to={"/race/" + race.id}>
                                                                    <IconButton aria-label='Desabilitar' title='Ver'>
                                                                        <Forward />
                                                                    </IconButton>
                                                                </Link>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </div>
                                    )
                                ))}
                            </Paper>
                        )}
                    </Paper>
                ))}

                {planning.routings.length === 0 && (
                    <Paper style={{ padding: 16 }}>
                        <Typography  color="textSecondary" style={{ textAlign: 'center' }}>
                            No hay routings asignados a esta planificación
                        </Typography>
                    </Paper>
                )}
            </DialogContent>

            <DialogActions>
                <Button onClick={props.onClose} color="primary">
                    Cerrar
                </Button>
            </DialogActions>
        </Dialog>
    );
};


// WEBPACK FOOTER //
// ./src/components/PlanningDetailsModal.tsx